<template>
  <div
    :class="[
      'card shadow rounded product-card aspect-1-1 rounded-3 product-photo overflow-hidden rounded-5 position-relative',
      { pressEffect: isPressing },
    ]"
    @click="addToOrder"
    :id="product.barcode"
  >
    <div class="card-body d-flex justify-content-center align-items-center position-relative p-0">
      <img :src="product.photo ?? '/gallery.png'" class="aspect-1-1" alt="..." />
      <div class="product-text m-1 rounded-3">
        <p class="fw-bold text-white text-center mb-0 pt-1">{{ product.name }}</p>
        <div class="text-center">
          <small
            v-if="product.unit"
            class="badge bg-label-primary ms-1 p-1"
            style="font-size: 10px"
          >
            {{ product.unit }}
          </small>
          <small
            v-if="product.info"
            class="badge bg-label-primary ms-1 p-1"
            style="font-size: 10px"
          >
            {{ product.info }}
          </small>
        </div>
        <h5
          class="text-white text-center my-1"
          :style="product.unit ? 'font-size:14px' : ''"
        >
          {{ removeDecimal(product.sale_price) }}
        </h5>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import removeDecimal from "../../composables/useRemoveDecimal";
import { outofstockalert } from "@/composables/useAlert";
import { pusher } from "@/pusher";

export default {
  props: ["product"],
  setup(props) {
    const store = useStore();
    const isPressing = ref(false);

    // Computed helpers
    const currentHoldPro = computed(() =>
      store.state.order.holdOrders.find((hold) =>
        hold.order_products.find((hl) => hl.id === props.product.id)
      )
    );

    const isIncludeProduct = computed(() =>
      store.state.order.holdOrders.some((hod) =>
        hod?.order_products.some((op) => op.id === props.product.id)
      )
    );

    const countOrd = computed(() =>
      store.state.order.orders.find((od) => od.id === props.product.id)
    );

    const holdOrders = computed(() =>
      store.state.order.holdOrders.filter((hold) =>
        hold.order_products.find((hl) => hl.id === props.product.id)
      )
    );

    const addToOrder = () => {
      isPressing.value = true;
      setTimeout(() => (isPressing.value = false), 500);

      const productData = {
        id: props.product.id,
        name: props.product.name,
        barcode: props.product.barcode,
        left_qty: props.product.left,
        unit: props.product.unit,
        info: props.product.info,
        qty: 1,
        count: 0,
        price: props.product.sale_price,
        purchase_total: props.product.purchase_price,
        purchase_price: props.product.purchase_price,
        wholesale_price: props.product.wholesale_price,
        sale_price: props.product.sale_price,
        total: props.product.sale_price * 1,
      };

      // Check stock with holdOrders
      if (store.state.order.holdOrders.length > 0 && isIncludeProduct.value) {
        if (currentHoldPro.value) {
          const realProduct = currentHoldPro.value.order_products.filter(
            (opd) => opd.id === props.product.id
          );
          let realProductQty = holdOrders.value.reduce((acc, hov) => {
            return acc + hov.order_products.find((hop) => hop.id === props.product.id).qty;
          }, 0);

          const left_qty = realProduct[0].left_qty - realProductQty;
          const currentProductQty = store.state.order.orders.find(
            (ord) => ord.id === props.product.id
          )?.qty || 0;

          if (currentProductQty + 1 > left_qty) {
            outofstockalert();
            return;
          }
        }
      }

      // Check stock in orders
      const existedOrder = store.state.order.orders.find(
        (order) => order.id === props.product.id
      );
      const currentOrderQty = existedOrder?.qty || 0;

      if (currentOrderQty + 1 > props.product.left) {
        outofstockalert();
        return;
      }

      existedOrder
        ? store.dispatch("incOrder", productData.id)
        : store.dispatch("addOrder", productData);
    };

    onMounted(() => {
  const user_code = store.state.auth.authUser.user_code;
  if (!user_code) return;

  const channel = pusher.subscribe(user_code); // ✅ now pusher is defined
  channel.bind("orders", (data) => {
    if (data.id === props.product.id) {
      addToOrder();
    }
  });
});
    return { addToOrder, isPressing, removeDecimal };
  },
};
</script>

<style lang="scss" scoped></style>
